import recursos from "./recursos";
import reservas from "./reservas";

export default {
  recursos,
  reservas,
};
